import { BanTable } from './BanTable'
import { withBanTable } from './withBanTable'

const ConnectedBanTable = withBanTable(BanTable)

export { ConnectedBanTable as BanTable }
